export function sortByKey<T>(
  arr: T[],
  key: keyof T,
  direction: 'asc' | 'desc'
): T[] {
  const clone = [...arr];
  return clone.sort((a, b) => {
    const aSortValue = a[key];
    const bSortValue = b[key];

    return direction === 'asc'
      ? sortAsc(aSortValue, bSortValue)
      : sortDesc(aSortValue, bSortValue);
  });
}

function sortAsc<T>(aSortValue: T[keyof T], bSortValue: T[keyof T]) {
  if (aSortValue > bSortValue) {
    return 1;
  }
  if (bSortValue > aSortValue) {
    return -1;
  }
  return 0;
}

function sortDesc<T>(aSortValue: T[keyof T], bSortValue: T[keyof T]) {
  if (bSortValue > aSortValue) {
    return 1;
  }
  if (aSortValue > bSortValue) {
    return -1;
  }
  return 0;
}
